import { Info } from '@mui/icons-material';
import {
  Box,
  Typography,
  LinearProgress,
  Tooltip,
  Divider,
} from '@mui/material';

const ProgressCard = ({ ProgressDetails }) => {
  // const { min_club_info, max_club_info, current_info } = ProgressDetails.slider_info;
  //   const percent = Math.min(100,Math.max(
  //     0,((current_info.current_value - min_club_info.club_min_value) / (max_club_info.club_min_value - min_club_info.club_min_value)) * 100,
  //   ),
  // );
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: { lg: 2 },
          mt: 2,
        }}
      >
        <Box sx={{ display:'flex', alignItems: 'center' }}>
          <Box>
            <img
              src={ProgressDetails.logo}
              alt='logo'
              style={{ width: '80px' }}
            />
          </Box>
          <Box sx={{ ml:{xs: .5, md: 2} }}>
            <Typography
              sx={{ fontWeight: 'bold', fontSize: '14px' }}
            >
              {ProgressDetails.title}
            </Typography>
            <Typography
              sx={{
                // color: ProgressDetails?.subtitle_color,
                fontWeight: 'bold',
                fontSize: '12px'
              }}
            >
              {ProgressDetails?.subtitle}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography
            variant='body2'
            sx={{
              // color: ProgressDetails.description.color,
              // background: ProgressDetails.description.bg_color,
              textAlign: 'center',
              borderRadius: '20px',
              fontWeight: 'bold',
              px: '15px',
              py: '5px',
              fontSize: '12px',
            }}
          >
            {ProgressDetails?.description?.display_name}
          </Typography>
        </Box>
      </Box>
      {/* <Box sx={{ width: '100%' }}>
        <Box sx={{ position: 'relative' }}>
          <LinearProgress
            variant='determinate'
            value={percent}
            sx={{
              height: 10,
              borderRadius: 5,
              mb: 1,
              '& .MuiLinearProgress-bar': {
                backgroundColor: current_info.value_color,
                
              },
              backgroundColor: '#E0E0E0',
            }}
          />
          <Box
            sx={{
             
              position: 'absolute',
              top: -30,
              left: `${percent}%`,
              transform:
                current_info?.current_value === min_club_info?.club_min_value
                  ? 'translateX(0)'
                  : current_info?.current_value === max_club_info?.club_min_value
                  ? 'translateX(-100%)'
                  : 'translateX(-50%)',
              color: current_info?.value_color,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center',  width: '100%', }}>
              <Typography sx={{ mr: 1, fontSize: '14px', minWidth: 'max-content' }}>
                {current_info?.current_value}{' '}
                {ProgressDetails?.slider_info?.uom}
              </Typography>
              <Tooltip
                title={`${current_info?.info}`}
                arrow
                placement='top'
              >
                <Info fontSize='small' />
              </Tooltip>
            </Box>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: `${percent}%`,
              transform: 'translate(-50%, -50%)',
              width: 15,
              height: 15,
              borderRadius: '50%',
              backgroundColor: current_info?.value_color,
              zIndex: 1,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '100%',
              transform: 'translate(-50%, -50%)',
              width: 15,
              height: 15,
              borderRadius: '50%',
              backgroundColor: '#9B9B9B',
              zIndex: 1,
            }}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography
              sx={{
                color: min_club_info?.name_color,
                mb: 0.5,
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {min_club_info?.display_name}
            </Typography>
            <Typography
              sx={{
                color: min_club_info?.level_color,
                mb: 0.5,
                fontSize: '14px',
              }}
            >
              {min_club_info?.level}
            </Typography>
            <Typography sx={{ mb: 1, fontSize: '14px' }}>
              {min_club_info?.club_min_value}{' '}
              {ProgressDetails?.slider_info?.uom}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                color: max_club_info?.name_color,
                mb: 0.5,
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {max_club_info?.display_name}
            </Typography>
            <Typography
              sx={{
                color: max_club_info?.level_color,
                mb: 0.5,
                fontSize: '14px',
              }}
            >
              {max_club_info?.level}
            </Typography>
            <Typography sx={{ mb: 1, fontSize: '14px' }}>
              {max_club_info?.club_min_value}{' '}
              {ProgressDetails?.slider_info?.uom}
            </Typography>
          </Box>
        </Box>*/}

        {ProgressDetails.next_club_txt && <Divider sx={{ my: 2 }} />}

        {ProgressDetails.next_club_txt && 
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box>
              <Typography sx={{ mb: 1 }}>
                {ProgressDetails?.next_club_txt?.display_name}
              </Typography>
            </Box>
          
            <Box sx={{ width: 'fit-content' }}>
              <Typography
                variant='body2'
                sx={{
                  color: ProgressDetails?.description?.color,
                  background: ProgressDetails?.description?.bg_color,
                  textAlign: 'center',
                  borderRadius: '20px',
                  fontWeight: 'bold',
                  px: '15px',
                  py: '5px',
                  fontSize: '12px',
                }}
              >
                {ProgressDetails?.next_club_txt?.range?.display_name}
              </Typography> 
            </Box>
            {/* <Typography
              sx={{
                color: ProgressDetails?.next_club_txt?.value_txt?.value_color,
                fontSize: '20px',
              }}
            >
              {ProgressDetails?.next_club_txt?.value_txt?.value}
            </Typography> */}
          </Box>
        } 
    </Box>
    
  );
};

export default ProgressCard;
